import { createContext, useReducer, useEffect } from "react";

export const OrdersContext = createContext()

export function ordersReducer(state, action) {
    switch(action.type) {
        case "SET_ORDERS" :
            return action.payload
        case "UPDATE_ORDER" :
            return state.map(e => {
                if(e._id === action.payload._id) {
                    return { ...e, status: action.payload.status }
                } else {
                    return e
                }
            })
        default :
            return state
    }
}

export function OrdersContextProvider({ children }) {
    const [state, dispatch] = useReducer(ordersReducer, null)
    //${process.env.REACT_APP_API_BASE_URL}
    useEffect(() => {
        async function fetchOrders() {
            //const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/getOrders`)
            const response = await fetch(`http://localhost:3001/api/getOrders`)
            const json = await response.json()

            if(response.ok) {
                dispatch({ type: "SET_ORDERS", payload: json })
            }
        }

        fetchOrders()
    }, [])

    return (
        <OrdersContext.Provider value={{ state, dispatch }}>
            {children}
        </OrdersContext.Provider>
    )
} 